import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {CarBrand, CarType, DamageReport, Employee, Importer, Insurance, JobType, Log, Receiver, DamageArea, DamageCase, DamageType, Feed, Response, Damage} from '../models/models';
import {environment} from '../../environments/environment';

const apiPath = environment.apiPath + 'DamageAdministration/';

@Injectable({
  providedIn: 'root'
})
export class DamageAdministrationService {

  constructor(private httpClient: HttpClient) { }

  /* Employee */

  insertEmployee(employee: Employee): Observable<Response<Employee>> {
    return this.httpClient.post<Response<Employee>>(apiPath + 'Employee/' + sessionStorage.getItem('UserId') + '/ByUser', employee);
  }

  updateEmployee(id: number, employee: Employee): Observable<Response<Employee>> {
    return this.httpClient.put<Response<Employee>>(apiPath + id + '/Employee/' + sessionStorage.getItem('UserId') + '/ByUser', employee);
  }

  deleteEmployee(id: number): Observable<Response<boolean>> {
    return this.httpClient.delete<Response<boolean>>(apiPath + id + '/Employee/' + sessionStorage.getItem('UserId') + '/ByUser');
  }

  getEmployees(): Observable<Response<Employee[]>> {
    return this.httpClient.get<Response<Employee[]>>(apiPath + 'Employee');
  }

  GetEmployeeByUniqueId(employeeId: number): Observable<Response<Employee>> {
    return this.httpClient.get<Response<Employee>>(apiPath + 'Employee/' + employeeId + '/EmployeeId');
  }

  /* CarBrand */

  insertCarBrand(carBrand: CarBrand): Observable<Response<CarBrand>> {
    return this.httpClient.post<Response<CarBrand>>(apiPath + 'CarBrand/' + sessionStorage.getItem('UserId') + '/ByUser', carBrand);
  }

  updateCarBrand(id: number, carBrand: CarBrand): Observable<Response<CarBrand>> {
    return this.httpClient.put<Response<CarBrand>>(apiPath + id + '/CarBrand/' + sessionStorage.getItem('UserId') + '/ByUser', carBrand);
  }

  deleteCarBrand(id: number): Observable<Response<boolean>> {
    return this.httpClient.delete<Response<boolean>>(apiPath + id + '/CarBrand/' + sessionStorage.getItem('UserId') + '/ByUser');
  }

  getCarBrands(): Observable<Response<CarBrand[]>> {
    return this.httpClient.get<Response<CarBrand[]>>(apiPath + 'CarBrand');
  }

  getCarBrandByCarBrandId(carBrandId: number): Observable<Response<CarBrand>> {
    return this.httpClient.get<Response<CarBrand>>(apiPath + 'CarBrand/' + carBrandId + '/CarBrandId');
  }

  getCarBrandsByImporterId(importerId: number): Observable<Response<CarBrand[]>> {
    return this.httpClient.get<Response<CarBrand[]>>(apiPath + 'CarBrand/' + importerId + '/ImporterId');
  }

  /* CarType */

  insertCarType(carType: CarType): Observable<Response<CarType>> {
    return this.httpClient.post<Response<CarType>>(apiPath + 'CarType/' + sessionStorage.getItem('UserId') + '/ByUser', carType);
  }

  updateCarType(id: number, carType: CarType): Observable<Response<CarType>> {
    return this.httpClient.put<Response<CarType>>(apiPath + id + '/CarType/' + sessionStorage.getItem('UserId') + '/ByUser', carType);
  }

  deleteCarType(id: number): Observable<Response<boolean>> {
    return this.httpClient.delete<Response<boolean>>(apiPath + id + '/CarType/' + sessionStorage.getItem('UserId') + '/ByUser');
  }

  getCarTypes(): Observable<Response<CarType[]>> {
    return this.httpClient.get<Response<CarType[]>>(apiPath + 'CarType');
  }

  getCarTypeByCarTypeId(carTypeId: number): Observable<Response<CarType>> {
    return this.httpClient.get<Response<CarType>>(apiPath + 'CarType/' + carTypeId + '/CarTypeId');
  }

  getCarTypesByCarBrandId(carBrandId: number): Observable<Response<CarType[]>> {
    return this.httpClient.get<Response<CarType[]>>(apiPath + 'CarType/' + carBrandId + '/CarBrandId');
  }

  /* Importer */

  insertImporter(importer: Importer): Observable<Response<Importer>> {
    return this.httpClient.post<Response<Importer>>(apiPath + 'Importer/' + sessionStorage.getItem('UserId') + '/ByUser', importer);
  }

  updateImporter(id: number, importer: Importer): Observable<Response<Importer>> {
    return this.httpClient.put<Response<Importer>>(apiPath + id + '/Importer/' + sessionStorage.getItem('UserId') + '/ByUser', importer);
  }

  deleteImporter(id: number): Observable<Response<boolean>> {
    return this.httpClient.delete<Response<boolean>>(apiPath + id + '/Importer/' + sessionStorage.getItem('UserId') + '/ByUser');
  }

  getImporters(): Observable<Response<Importer[]>>{
    return this.httpClient.get<Response<Importer[]>>(apiPath + 'Importer');
  }

  getImporterByImporterId(importerId: number): Observable<Response<Importer>> {
    return this.httpClient.get<Response<Importer>>(apiPath + 'Importer/' + importerId + '/ImporterId');
  }

  getImportersByImporterTransitId(importerTransitId: string): Observable<Response<Importer[]>> {
    return this.httpClient.get<Response<Importer[]>>(apiPath + 'Importer/' + importerTransitId + '/ImporterId');
  }

  /* Insurance */

  insertInsurance(insurance: Insurance): Observable<Response<Insurance>> {
    return this.httpClient.post<Response<Insurance>>(apiPath + 'Insurance/' + sessionStorage.getItem('UserId') + '/ByUser', insurance);
  }

  updateInsurance(id: number, insurance: Insurance): Observable<Response<Insurance>> {
    return this.httpClient.put<Response<Insurance>>(apiPath + id + '/Insurance/' + sessionStorage.getItem('UserId') + '/ByUser', insurance);
  }

  deleteInsurance(id: number): Observable<Response<boolean>> {
    return this.httpClient.delete<Response<boolean>>(apiPath + id + '/Insurance/' + sessionStorage.getItem('UserId') + '/ByUser');
  }

  getInsurances(): Observable<Response<Insurance[]>> {
    return this.httpClient.get<Response<Insurance[]>>(apiPath + 'Insurance');
  }

  getInsuranceByInsuranceId(insuranceId: number): Observable<Response<Insurance>> {
    return this.httpClient.get<Response<Insurance>>(apiPath + 'Insurance/' + insuranceId + '/InsuranceId');
  }

  /* JobType */

  insertJobType(jobType: JobType): Observable<Response<JobType>> {
    return this.httpClient.post<Response<JobType>>(apiPath + 'JobType/' + sessionStorage.getItem('UserId') + '/ByUser', jobType);
  }

  updateJobType(id: number, jobType: JobType): Observable<Response<JobType>> {
    return this.httpClient.put<Response<JobType>>(apiPath + id + '/JobType/' + sessionStorage.getItem('UserId') + '/ByUser', jobType);
  }

  deleteJobType(id: number): Observable<Response<boolean>> {
    return this.httpClient.delete<Response<boolean>>(environment.apiPath + id + '/JobType/' + sessionStorage.getItem('UserId') + '/ByUser');
  }

  getJobTypes(): Observable<Response<JobType[]>> {
    return this.httpClient.get<Response<JobType[]>>(apiPath + 'JobType');
  }

  getJobTypeByJobTypeId(jobTypeId: number): Observable<Response<JobType>> {
    return this.httpClient.get<Response<JobType>>(apiPath + 'JobType/' + jobTypeId + '/JobTypeId');
  }

  /* Receiver */

  insertReceiver(receiver: Receiver): Observable<Response<Receiver>> {
    return this.httpClient.post<Response<Receiver>>(apiPath + 'Receiver/' + sessionStorage.getItem('UserId') + '/ByUser', receiver);
  }

  updateReceiver(id: number, receiver: Receiver): Observable<Response<Receiver>> {
    return this.httpClient.put<Response<Receiver>>(apiPath + id + '/Receiver/' + sessionStorage.getItem('UserId') + '/ByUser', receiver);
  }

  deleteReceiver(id: number): Observable<Response<boolean>> {
    return this.httpClient.delete<Response<boolean>>(apiPath + id + '/Receiver/' + sessionStorage.getItem('UserId') + '/ByUser');
  }

  getReceivers(): Observable<Response<Receiver[]>> {
    return this.httpClient.get<Response<Receiver[]>>(apiPath + 'Receiver');
  }

  getReceiverByReceiverId(receiverId: number): Observable<Response<Receiver>> {
    return this.httpClient.get<Response<Receiver>>(apiPath + 'Receiver/' + receiverId + '/ReceiverId');
  }

  getReceiversByReceiverIdTransit(receiverIdTransit: string): Observable<Response<Receiver[]>> {
    return this.httpClient.get<Response<Receiver[]>>(apiPath + 'Receiver/' + receiverIdTransit + '/ReceiverIdTransit');
  }

  /* DamageReport */

  insertDamageReport(damageReport: DamageReport) {
    return this.httpClient.post<DamageReport>(apiPath + 'InsertDamageReport', { damageReport, userId: sessionStorage.getItem('UserId') });
  }

  updateDamageReport(damageReport: DamageReport) {
    return this.httpClient.post<DamageReport>(apiPath + 'UpdateDamageReport', { damageReport, userId: sessionStorage.getItem('UserId') });
  }

  deleteDamageReport(id: number) {
    return this.httpClient.delete<boolean>(apiPath + id + '/DamageReport/' + sessionStorage.getItem('UserId') + '/ByUser');
  }

  getDamageReports(): Observable<DamageReport[]> {
    return this.httpClient.get<DamageReport[]>(apiPath + 'DamageReport');
  }

  getDamageReportsInsertedByCotra(): Observable<DamageReport[]> {
    return this.httpClient.get<DamageReport[]>(apiPath + 'DamageReport/InsertedByCotra');
  }

  getDamageReportsInsertedByCustomer(): Observable<DamageReport[]> {
    return this.httpClient.get<DamageReport[]>(apiPath + 'DamageReport/InsertedByCustomer');
  }

  getDamageReportDocNums(): Observable<number[]> {
    return this.httpClient.get<number[]>(apiPath + 'DamageReport/DocNums');
  }

  getDamageReportByDocNum(docNum: number): Observable<DamageReport> {
    return this.httpClient.get<DamageReport>(apiPath + 'DamageReport/' + docNum + '/DocNum');
  }

  getDamageReportByTransitId(transitId: number): Observable<DamageReport> {
    return this.httpClient.get<DamageReport>(apiPath + 'DamageReport/' + transitId + '/TransitId');
  }

  /* DamageCase */

  insertDamageCase(damageCase: DamageCase): Observable<Response<DamageCase>> {
    return this.httpClient.post<Response<DamageCase>>(apiPath + 'InsertDamageCase', { damageCase, userId: sessionStorage.getItem('UserId') });
  }

  updateDamageCaseByCustomer(damageCase: DamageCase): Observable<Response<DamageCase>> {
    return this.httpClient.post<Response<DamageCase>>(apiPath + 'UpdateDamageCaseByCustomer', { damageCase, userId: sessionStorage.getItem('UserId') });
  }

  updateDamageCaseByCotra(damageCase: DamageCase): Observable<Response<DamageCase>> {
    return this.httpClient.post<Response<DamageCase>>(apiPath + 'UpdateDamageCaseByCotra', { damageCase, userId: sessionStorage.getItem('UserId') });
  }

  deleteDamageCase(id: number): Observable<Response<boolean>> {
    return this.httpClient.delete<Response<boolean>>(apiPath + id + '/DamageCase/' + sessionStorage.getItem('UserId') + '/ByUser');
  }
  
  getDamageCaseByTransitId(transitId: number): Observable<DamageCase> {
    return this.httpClient.get<DamageCase>(apiPath + 'DamageCase/' + transitId + '/TransitId');
  }

  getDamageCaseById(id: number): Observable<Response<DamageCase>> {
    return this.httpClient.get<Response<DamageCase>>(apiPath + 'DamageCase/' + id);
  }

  getOpenDamageCasesByPrimaryAddressId(primaryAddressId: number): Observable<Response<DamageCase[]>> {
    return this.httpClient.get<Response<DamageCase[]>>(apiPath + 'OpenDamageCase/' + primaryAddressId + '/PrimaryAddress');
  }

  getClosedDamageCasesByPrimaryAddressId(primaryAddressId: number): Observable<Response<DamageCase[]>> {
    return this.httpClient.get<Response<DamageCase[]>>(apiPath + 'ClosedDamageCase/' + primaryAddressId + '/PrimaryAddress');
  }

  getDamageCaseIds(): Observable<Response<number[]>> {
    return this.httpClient.get<Response<number[]>>(apiPath + 'DamageCase/Ids');
  }

  getDamageCases(): Observable<Response<DamageCase[]>> {
    return this.httpClient.get<Response<DamageCase[]>>(apiPath + 'DamageCase');
  }

  getDamageCasesWithNewFeed(primaryAddressId: number): Observable<Response<number[]>> {
    return this.httpClient.get<Response<number[]>>(apiPath + 'DamageCase/NewFeeds/' + primaryAddressId);
  }

  /* Damage */

  requestAdditionalFotos(damage: Damage, option: string): Observable<Response<DamageCase>> {
    return this.httpClient.post<Response<DamageCase>>(apiPath + 'RequestAdditionalFotos', { damage, option });
  }

  /* DamageArea */

  getDamageAreas(): Observable<Response<DamageArea[]>> {
    return this.httpClient.get<Response<DamageArea[]>>(apiPath + 'DamageArea');
  }

  /* DamageType */

  getDamageTypes(): Observable<Response<DamageType[]>> {
    return this.httpClient.get<Response<DamageType[]>>(apiPath + 'DamageType');
  }

  /* Feed */

  insertFeed(feed: Feed): Observable<Response<Feed>> {
    return this.httpClient.post<Response<Feed>>(apiPath + 'InsertFeed', feed);
  }

  resetFeedStateByCaseId(id: number): Observable<Response<boolean>> {
    return this.httpClient.get<Response<boolean>>(apiPath + 'ResetFeedState/' + id);
  }

  /* Log */

  getLogs(): Observable<Response<Log[]>> {
    return this.httpClient.get<Response<Log[]>>(apiPath + 'Log');
  }

  /* Evaluation */

  getDamageStatisticsByEmp(startDate: string, endDate: string): Observable<any> {
    return this.httpClient.get<any>(apiPath + 'Evaluation/' + startDate + '/' + endDate + '/Emp');
  }

  getDamageStatisticsByRec(startDate: string, endDate: string): Observable<any> {
    return this.httpClient.get<any>(apiPath + 'Evaluation/' + startDate + '/' + endDate + '/Rec');
  }

  getDamageStatisticsByImp(startDate: string, endDate: string): Observable<any> {
    return this.httpClient.get<any>(apiPath + 'Evaluation/' + startDate + '/' + endDate + '/Imp');
  }

  getDamageStatisticsByJobType(startDate: string, endDate: string): Observable<any> {
    return this.httpClient.get<any>(apiPath + 'Evaluation/' + startDate + '/' + endDate + '/JobType');
  }

  getAdditionalDataFromDamage(startDate: string, endDate: string, uniqueId: string, property: string, mode: string): Observable<any> {
    return this.httpClient.post<any>(apiPath + 'Evaluation/' + startDate + '/' + endDate + '/' + property + '/' + mode + '/Additional', { uniqueId });
  }

  getPieChartData(startDate: string, endDate: string, uniqueId: string, mode: string): Observable<any> {
    return this.httpClient.post<any>(apiPath + 'Evaluation/' + startDate + '/' + endDate + '/' + mode + '/PieChart', { uniqueId });
  }
}
